import {useNavigation} from '@react-navigation/native';
import React from 'react';
import {LayoutChangeEvent, Platform, TouchableOpacity, View} from 'react-native';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import {Screens} from '../../routing';
import {Image} from '../image';
import {Text} from '../text';
import {Props} from './model';
import {normalizeUrl, stripHTML} from '../../pipes';
import {GetStyle} from './style';

const dataViewAttrs = {
  dataSet: {
    class: 'news-card',
  },
};

export default ({news, containerStyles, style, onLayout, ...rest}: Props) => {
  const {id} = news;
  const isDesktop = useIsDesktop();
  const navigation = useNavigation();
  const [imageHeight, setImageHeight] = React.useState(0);

  const styles = GetStyle(imageHeight);

  const handleLayout = React.useCallback(
    (event: LayoutChangeEvent) => {
      onLayout && onLayout(event);
      setImageHeight((event.nativeEvent.layout.width / 3) * 2);
    },
    [onLayout],
  );
  return (
    <TouchableOpacity
      testID={`news-card-${id}-id`}
      activeOpacity={Platform.OS === 'web' ? 1 : 0.5}
      onPress={() => navigation.navigate(Screens.NewsArticle, {id})}
      style={containerStyles}>
      <View
        testID={`news-card-${id}-container-id`}
        style={[styles.container, style]}
        onLayout={handleLayout}
        {...dataViewAttrs}
        {...rest}>
        {news.image ? (
          <Image
            testID={`news-card-${id}-image-id`}
            source={{uri: normalizeUrl(news.image)}}
            style={styles.image}
            resizeMode='cover'
          />
        ) : (
          <View testID={`news-card-${id}-image-holder-id`} style={styles.image} />
        )}
        <View testID={`news-card-${id}-text-container-id`} style={styles.textContainer}>
          <Text
            testID={`news-card-${id}-createdAt-id`}
            type={isDesktop ? 'body' : 'bodySmallLight'}
            style={styles.date}>
            {news.createdAt}
          </Text>
          <Text testID={`news-card-${id}-name-id`} style={styles.textHeader} type={isDesktop ? 'h5' : 'action'}>
            {news.name}
          </Text>
          <Text
            testID={`news-card-${id}-description-id`}
            type={isDesktop ? 'body' : 'bodySmallLight'}
            style={styles.description}
            numberOfLines={8}
            ellipsizeMode='tail'>
            {stripHTML(news.description)}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};
